<template>
  <div class="MswContainer">
    <!-- <v-toolbar bottom right permanent absolute color="red" class=""> -->

    <v-card color="toolBar3" max-width="170" class="MswCard" :style="{
      transform: LeftLayersStyleTransform,
    }" :class="[SwipeLineOrientation == 1 ? 'mt-n1' : 'mt-1 ml-n1']">
      <v-list dense color="transparent">
        <!-- <v-subheader>levý panel</v-subheader> -->
        <v-list-item-group v-model="LeftLayers" color="accent2" multiple>
          <v-list-item v-for="(item, i) in MapLegendLayersVisible" :key="i" dense :value="item.layer" class="">
            <v-list-item-content>
              <v-list-item-title v-html="item.label"></v-list-item-title>
              <v-list-item-subtitle v-html="item.labelsub"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
    <!-- Rozdělující čára -->
    <div class="MswCard MswCenterLine" :style="{
      transform: CenterLineStyleTransform,
    }" :class="[
      SwipeLineOrientation == 1
        ? 'MswCenterLine-horizontal'
        : 'MswCenterLine-vertical',
    ]" />
    <v-card color="toolBar3" max-width="170" class="MswCard" :style="{
      transform: RightLayersStyleTransform,
    }" :class="[SwipeLineOrientation == 1 ? 'mt-1' : 'mt-1 ml-1']">
      <v-list dense color="transparent">
        <!-- <v-subheader>pravý panel</v-subheader> -->
        <v-list-item-group v-model="RightLayers" color="accent2" multiple>
          <v-list-item v-for="(item, i) in MapLegendLayersVisible" :key="i" dense :value="item.layer">
            <v-list-item-content>
              <v-list-item-title v-html="item.label"></v-list-item-title>
              <v-list-item-subtitle v-html="item.labelsub"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
    <!-- </v-toolbar> -->
  </div>
</template>

<script>
//import { SwipeMap } from "../function/controller/SwipeMap";
import { SwipeController } from "@luciad/ria/view/controller/SwipeController";

export default {
  props: {
    // Mapa
    Map: Object,
    // Mapové vrstvy
    MapLegendLayers: null,
  },

  data() {
    return {
      // Controll
      SwipeMapControll: null,
      // orinetace rozdělení 2 VERTICAL (výchozí) 1 HORIZONTAL
      SwipeLineOrientation: 2,
      // poloha rozdělení
      SwipeLineLocation: Object,
      // kursor nad
      IsHovering: false,
      // Vybrané vrstvy prvního panelu
      LeftLayers: [],
      // Vybrané vrstvy prvního panelu - zda se sleduje změna
      LeftLayersWatch: true,
      // css transformace panelu
      LeftLayersStyleTransform: "",
      // Vybrané vrstvy druhého panelu
      RightLayers: [],
      // Vybrané vrstvy druhého panelu - zda se sleduje změna
      RightLayersWatch: true,
      // css transformace panelu
      RightLayersStyleTransform: "",
      // css transformace rozdělující linie
      CenterLineStyleTransform: "",
    };
  },

  computed: {
    // Viditelné mapové vrstvy a ne podřízené (definice parentLayerGroup)
    MapLegendLayersVisible: function () {
      return this.MapLegendLayers.filter(function (item) {
        return (item.layer.visible && !item.parentLayerGroup);
      });
    },
  },

  watch: {
    LeftLayers: function (value) {
      if (this.LeftLayersWatch) {
        var _this = this;
        // odebrat položky v tomto seznamu z druhého - nemůže být najednou výběr v obou
        value.forEach(function (item) {
          // Najít položku ve druhém seznamu a odvybrat
          const index = _this.RightLayers.indexOf(item);
          if (index > -1) {
            _this.RightLayersWatch = false;
            _this.RightLayers.splice(index, 1);
          }
        });
      }
      // poslat změnu do SwipeMapControll
      if (
        typeof this.SwipeMapControll !== "undefined" &&
        this.SwipeMapControll != null
      ) {
        this.SetSwipeMapControllLayers(this.LeftLayers, this.RightLayers);
      }
      this.LeftLayersWatch = true;
    },

    RightLayers: function (value) {
      if (this.RightLayersWatch) {
        var _this = this;
        // odebrat položky v tomto seznamu z druhého - nemůže být najednou výběr v obou
        value.forEach(function (item) {
          // Najít položku ve druhém seznamu a odvybrat
          const index = _this.LeftLayers.indexOf(item);
          if (index > -1) {
            _this.LeftLayersWatch = false;
            _this.LeftLayers.splice(index, 1);
          }
        });
      }
      // poslat změnu do SwipeMapControll
      if (
        typeof this.SwipeMapControll !== "undefined" &&
        this.SwipeMapControll != null
      ) {
        this.SetSwipeMapControllLayers(this.LeftLayers, this.RightLayers);
      }
      this.RightLayersWatch = true;
    },

    IsHovering: function (value) {
      if (value) {
        this.Map.domNode.style.cursor =
          this.SwipeLineOrientation == 2 ? "col-resize" : "row-resize";
      } else {
        this.Map.domNode.style.cursor = "auto";
      }
    },
  },

  methods: {
    SwipeLineOrientationChange: function (value) {
      // Změna orientace rozdělení
      this.SwipeLineOrientation = value;
    },

    SwipeLineLocationChange: function (value) {
      // Změna polohy rozdělení
      this.SwipeLineLocation = value;
      // umístění panelů - posunutí
      this.LeftLayersStyleTransform =
        this.SwipeLineOrientation == 2
          ? "translate(" + value.x + "px, 0px) translateX(-100%)"
          : "translate(52px, " + value.y + "px) translateY(-100%)";

      this.RightLayersStyleTransform =
        this.SwipeLineOrientation == 2
          ? "translate(" + value.x + "px, 0px)"
          : "translate(52px, " + value.y + "px)";

      this.CenterLineStyleTransform =
        this.SwipeLineOrientation == 2
          ? "translate(" + value.x + "px, 0px) translateX(-50%)"
          : "translate(0px, " + value.y + "px) translateY(-50%)";
    },

    SwipeLHoveringChanged: function () {
      // Kurzor nad rozdělením
      this.IsHovering =
        this.SwipeMapControll.swiping || this.SwipeMapControll.hovering;
    },


    SetSwipeMapControllLayers: function (LeftLayers, RightLayers) {
      // Nastavení seznamu pro překreslení
      // Do seznamu je třeba doplnit případné podřízené vrstvy (v definici mají definován parentLayerGroup)

      var nLeftLayers = [];
      var nRightLayers = [];

      LeftLayers.forEach(
        function (item) {
          nLeftLayers.push(item)
          item.children.forEach(
            function (item2) {
              nLeftLayers.push(item2)
            }
          )
        }
      )

      RightLayers.forEach(
        function (item) {
          nRightLayers.push(item)
          item.children.forEach(
            function (item2) {
              nRightLayers.push(item2)
            }
          )
        }
      )

      this.SwipeMapControll.layers = [nLeftLayers, nRightLayers];

    },

    // Přidání / odebrání mapového kontroleru
    MapControllerActiveChange: function (removeIds, addContrs) {
      this.$emit('MapControllerActiveChange', removeIds, addContrs);
    },


  },

  mounted() {
    // Inicializace
    // console.log("MapSwipe mounted");

    var _this = this;

    // Výchozí nastavení vrstev - nalevo všechny viditelné, napravo nic
    this.MapLegendLayersVisible.forEach(function (item) {
      _this.LeftLayers.push(item.layer);
    });

    // nový SwipeController
    this.SwipeMapControll = new SwipeController();
    this.SetSwipeMapControllLayers(this.LeftLayers, this.RightLayers);

    this.SwipeLineOrientation = this.SwipeMapControll.swipeLineOrientation;
    this.SwipeLineLocation = this.SwipeMapControll.swipeLineLocation;

    //Naslouchání události SwipeLineOrientationChange
    const orientationChangedListener = this.SwipeMapControll.on(
      "SwipeLineOrientationChange",
      this.SwipeLineOrientationChange
    );

    //Naslouchání události SwipeLineLocationChange
    const swipeLocationListener = this.SwipeMapControll.on(
      "SwipeLineLocationChange",
      this.SwipeLineLocationChange
    );

    //Naslouchání události HoveringChanged
    const hoverChangeListener = this.SwipeMapControll.on(
      "HoveringChanged",
      this.SwipeLHoveringChanged
    );
    //Naslouchání události HoveringChanged
    const SwipingChangedListener = this.SwipeMapControll.on(
      "SwipingChanged",
      this.SwipeLHoveringChanged
    );

    // Zrušení naslouchání
    this.SwipeMapControll.return = function () {
      orientationChangedListener.remove();
      swipeLocationListener.remove();
      hoverChangeListener.remove();
      SwipingChangedListener.remove();
    };

    this.MapControllerActiveChange([], [{ id: 'McSwipeMap', contr: this.SwipeMapControll }])
  },

  destroyed() {
    // Inicializace
    // console.log("MapSwipe destroyed");
    this.SwipeMapControll.return();
    this.MapControllerActiveChange(['McSwipeMap'], [])
  },
};
</script>

<style scoped>
.MswContainer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.MswCard {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.MswCenterLine {
  pointer-events: none;
}

.MswCenterLine-horizontal {
  width: 100%;
  flex-direction: row;
  height: 8px;
  border-top: 2px dashed salmon;
  border-bottom: 2px dashed salmon;
}

.MswCenterLine-vertical {
  height: 100%;
  flex-direction: column;
  width: 8px;
  border-left: 2px dashed salmon;
  border-right: 2px dashed salmon;
}
</style>